import { createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'

const initialState = {
  ip: '',
  description: '',
  maxLength: 30,
  error: null,
}

export const addRestrictionIp = createAxiosThunk(
  'restrictionIpAdd/addRestrictionIp',
  (noArgs, { getState }) => {
    const {
      restrictionIpAdd: { ip, description },
    } = getState().restrictionIp
    return api.restrictionIp.addRestrictionIp({ ip, description })
  }
)

const restrictionIpAddSlice = createSlice({
  name: 'restrictionIpAdd',
  initialState,
  reducers: {
    reset: () => initialState,
    setIp: (state, { payload: ip }) => {
      state.ip = ip
    },
    setDescription: (state, { payload: description }) => {
      state.description = description
    },
  },
})

export const { reset, setIp, setDescription } = restrictionIpAddSlice.actions
export default restrictionIpAddSlice.reducer
